import React, { useEffect, useState } from "react";
import api from "../api";
import { UserCheck, Eye, Clock } from "lucide-react";
import { RUBRIQUE_BY_ID } from "../rubriques";
import { RenderStructuredValue } from "../formatProfil";

export default function Partenaire() {
  const [carnets, setCarnets] = useState(null);
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    api.get("/partenaire/carnets").then((r) => setCarnets(r.data.carnets));
  }, []);

  const openCarnet = async (carnetId) => {
    setSelected(carnetId); setDetail(null);
    const { data } = await api.get(`/partenaire/carnets/${carnetId}`);
    setDetail(data);
  };

  if (!carnets) return <div>Chargement…</div>;

  return (
    <div className="space-y-8">
      <div>
        <div style={{ color: "var(--auprea-gold)", fontSize: 12, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>
          — Espace partenaire
        </div>
        <h1 style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }} data-testid="partenaire-title">Carnets partagés avec vous</h1>
        <p style={{ fontSize: 17, color: "rgba(35,38,46,0.7)", marginTop: 8 }}>
          Accès en lecture seule, durée limitée. Aucune modification possible.
        </p>
      </div>

      {carnets.length === 0 ? (
        <div className="auprea-card text-center" style={{ color: "rgba(35,38,46,0.6)" }} data-testid="partenaire-empty">
          Aucun carnet ne vous a été partagé pour le moment.
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {carnets.map((c) => (
            <button
              key={c.carnet_id}
              onClick={() => openCarnet(c.carnet_id)}
              className="auprea-card text-left hover:bg-white"
              style={{ borderColor: selected === c.carnet_id ? "var(--auprea-gold)" : undefined }}
              data-testid={`partenaire-carnet-${c.carnet_id}`}
            >
              <div className="flex items-start gap-3">
                <UserCheck size={28} color="#1d3a72" />
                <div className="flex-1">
                  <div style={{ fontFamily: "Spectral, serif", fontSize: 20, color: "var(--auprea-navy)" }}>{c.owner_name}</div>
                  <div style={{ fontSize: 13, color: "rgba(35,38,46,0.6)" }}>{c.owner_email}</div>
                  <div style={{ fontSize: 12, marginTop: 8, color: "var(--auprea-blue)" }}>
                    <Clock size={12} style={{ display: "inline", marginRight: 4 }} />
                    Expire le {new Date(c.partage.expiration).toLocaleDateString("fr-FR")}
                  </div>
                  <div style={{ fontSize: 12, marginTop: 4, color: "rgba(35,38,46,0.6)" }}>
                    {c.partage.rubriques.length} rubrique(s) accessible(s)
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}

      {selected && detail && (
        <div className="auprea-card">
          <div className="flex items-center justify-between mb-4">
            <h2 style={{ fontSize: 24 }}>Carnet de {detail.owner_name}</h2>
            <span style={{ fontSize: 13, color: "var(--auprea-blue)" }}>
              <Eye size={14} style={{ display: "inline", marginRight: 4 }} /> Lecture seule
            </span>
          </div>
          {detail.rubriques_partagees.map((rubId) => {
            const rub = RUBRIQUE_BY_ID[rubId];
            const data = detail.profil?.[rubId] || {};
            return (
              <div key={rubId} className="py-4 border-t" style={{ borderColor: "rgba(21,41,79,0.1)" }} data-testid={`partenaire-rub-${rubId}`}>
                <h3 style={{ fontSize: 18, marginBottom: 8 }}>{rub?.label || rubId}</h3>
                {rub?.fields.map((f) => (
                  data[f.key] && (
                    <div key={f.key} className="grid grid-cols-3 gap-4 py-1.5 text-sm">
                      <div style={{ color: "rgba(35,38,46,0.6)" }}>{f.label}</div>
                      <div className="col-span-2"><RenderStructuredValue value={data[f.key]} /></div>
                    </div>
                  )
                ))}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
